import type {
  AssetConditionRatingFieldProps,
  AssetConditionRatingFieldValue,
} from "./asset-condition-rating-field.type";

import { useTranslation } from "react-i18next";

import { FieldSelectTag } from "@/ui/field-select-tag";

import { getAssetConditionRatingMutateValue } from "./asset-condition-rating-field.helper";
import { useAssetConditionRatingField } from "./asset-condition-rating-field.hook";

import "./asset-condition-rating-field.style.less";

export const AssetConditionRatingField = ({
  label,
  loading,
  onChange,
  ...fieldProps
}: AssetConditionRatingFieldProps) => {
  const { t } = useTranslation();

  const { options, isLoading } = useAssetConditionRatingField();

  return (
    <FieldSelectTag
      {...fieldProps}
      label={label}
      options={options}
      loading={loading || isLoading}
      onChange={(value: AssetConditionRatingFieldValue) => {
        onChange?.(getAssetConditionRatingMutateValue(value));
      }}
      aria-label={label ?? t("global:conditionRating")}
      dropdownClassName="asset-condition-rating-field-dropdown"
    />
  );
};
